module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAcCAYAAAATFf3WAAAAAXNSR0IArs4c6QAAAOxJREFUWAntmDEOwjAMRZsKsbKCOAeHYGArWyVOwgADgntwN8QB2CjhuWpQ1IkmhHqIJTdO28RPP06ltCgSm7V2g986rxKnGz59B0bTWsO1Hj5LwhEAiXq+6YKErMIFyjd1kDV0GTK6UlExKxmtokyQlfyJjF8qaVwyZF8Sz13/j+2aXAe89HK+iHfGmGsLCNyeG0fvBQ2hBeJigJsQPPCpBqoeQ1Mi45Ob994DNV23xCuITvhiJLIZeWUPfPYEsSzxGR/XVH8TM1xocWTlsnKhCoSO015zWwD1nkeAU3/s9AF1HTelZlEw6tfHG6OGTbJgCjTBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/image/arrow_white.png
// module id = 3299
// module chunks = 0